import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Define route groups as static constants
const ORDER_ROUTES = [
  "/my-pending-orders",
  "/all-pending-orders",
  "/released-orders",
  "/all-released-orders",
  "/canceled-orders",
  "/starred-orders",
];

const PAYMENT_ROUTE = "/payments";

export default function RouteTransitionHandler() {
  const location = useLocation();
  const previousPath = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname;

    // Detect navigation FROM Payments → Orders
    if (
      previousPath.current === PAYMENT_ROUTE &&
      ORDER_ROUTES.includes(currentPath)
    ) {
      console.log("Navigated from Payments → Orders");
      sessionStorage.setItem("filterState", JSON.stringify([]));
    }

    // Detect navigation FROM Orders → Payments
    if (
      ORDER_ROUTES.includes(previousPath.current) &&
      currentPath === PAYMENT_ROUTE
    ) {
      console.log("Navigated from Orders → Payments");
      sessionStorage.setItem("filterState", JSON.stringify([]));
    }

    // Update previous path after logic
    previousPath.current = currentPath;
  }, [location]);

  return null; // Invisible listener component
}
